import { render, staticRenderFns } from "./AdminListProjectItem.vue?vue&type=template&id=287f4319&scoped=true&lang=html&"
import script from "./AdminListProjectItem.vue?vue&type=script&lang=js&"
export * from "./AdminListProjectItem.vue?vue&type=script&lang=js&"
import style0 from "./AdminListProjectItem.vue?vue&type=style&index=0&id=287f4319&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287f4319",
  null
  
)

export default component.exports